/**
 * Lightweight accessible accordion for FAQ (and any [data-accordion] block).
 * No dependency; animates max-height for a smooth, subtle open/close.
 */
(function () {
  function closePanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = null;
    trigger.closest('.accordion__item').classList.remove('is-open');
  }

  function openPanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'true');
    trigger.closest('.accordion__item').classList.add('is-open');
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    var triggers = accordion.querySelectorAll('[data-accordion-trigger]');
    triggers.forEach(function (trigger) {
      var panel = trigger.nextElementSibling;
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        triggers.forEach(function (t) {
          if (t !== trigger) closePanel(t, t.nextElementSibling);
        });
        if (isOpen) {
          closePanel(trigger, panel);
        } else {
          openPanel(trigger, panel);
        }
      });
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.accordion__trigger[aria-expanded="true"]').forEach(function (trigger) {
      var panel = trigger.nextElementSibling;
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  });
})();
